import { AxiosInstance } from "axios";
import { Prompt } from "../types";

interface PromptsApiResponse {
  prompts: Array<Prompt>;
  total: number;
  size: number;
  pages: number;
  hasMore: boolean;
}

interface CreatePromptRequest {
  promptIcon: string;
  promptTitle: string;
  promptVisibility: string;
  promptDescription: string;
  promptContent: string;
  favorite: boolean;
  promptType: string;
}

export const fetchPrompts = async (
  axios: AxiosInstance,
  params: {
    pageSize: number;
    pageNum: number;
    keyword?: string;
    favorite?: boolean;
    promptVisibility?: string;
    promptType?: string;
  }
): Promise<PromptsApiResponse> => {
  try {
    const response = await axios.get<PromptsApiResponse>(`/api/dataservice/v1/ai-chat/prompts`, {
      params,
    });

    const prompts: Prompt[] = Array.isArray(response.data) ? response.data : response.data.prompts;
    return {
      prompts: prompts,
      total: response.headers["total-elements"]
        ? parseInt(response.headers["total-elements"], 10)
        : response.data.total,
      size: response.headers["page-size"]
        ? parseInt(response.headers["page-size"], 10)
        : response.data.size,
      pages: response.headers["total-pages"]
        ? parseInt(response.headers["total-pages"], 10)
        : response.data.pages,
      hasMore:
        (params.pageNum + 1) * params.pageSize <
        (response.headers["total-elements"]
          ? parseInt(response.headers["total-elements"], 10)
          : response.data.total || 0),
    };
  } catch (error) {
    console.error("Failed to fetch prompts:", error);
    throw error;
  }
};

export const updatePrompt = async (
  axios: AxiosInstance,
  promptId: string,
  prompt: CreatePromptRequest
): Promise<Prompt> => {
  try {
    const response = await axios.put<Prompt>(
      `/api/dataservice/v1/ai-chat/prompts/${promptId}`,
      prompt
    );
    return response.data;
  } catch (error) {
    console.error("Failed to update prompt:", error);
    throw error;
  }
};

export const addPrompt = async (
  axios: AxiosInstance,
  prompt: CreatePromptRequest
): Promise<string> => {
  try {
    const response = await axios.post<string>(`/api/dataservice/v1/ai-chat/prompts`, prompt);
    return response.data;
  } catch (error) {
    console.error("Failed to add prompt:", error);
    throw error;
  }
};

export const deletePrompt = async (axios: AxiosInstance, promptId: string): Promise<void> => {
  try {
    await axios.delete(`/api/dataservice/v1/ai-chat/prompts/${promptId}`);
  } catch (error) {
    console.error("Failed to delete prompt:", error);
    throw error;
  }
};
